<ng-container *ngIf="isCartVisible">
  <a
    class="cart-btn btn btn-icon"
    (click)="navigateToCart()">
    <i
      class="cart-btn-icon ph-duotone ph-shopping-cart color-primary"
      [class.pulse-animation]="animateCart"></i>
    <ng-container *ngIf="cartItemsCount$ | async as count">
      <span
        class="cart-badge badge badge-number"
        *ngIf="count != 0"
        [class.pulse-animation]="animateCart"
        >{{ count }}</span
      >
    </ng-container>
  </a>
</ng-container>
